import { render, staticRenderFns } from "./Uat.vue?vue&type=template&id=b7e93410"
import script from "./Uat.vue?vue&type=script&lang=ts"
export * from "./Uat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports